<template>
	<el-table
			v-if=" !loading && propsData && show && tabData.length > 0"
			height="100%"
			:data="tabData"
			style="width: 100%">
		<el-table-column
				fixed
				label="数据类型"
				width="180"
		>

			<el-table-column
					prop="date"
					label="时间"
					width="160">
			</el-table-column>

		</el-table-column>

		<el-table-column
				fixed
				prop="total"
				label="总电量"
				width="160">
		</el-table-column>

		<el-table-column
				v-for="(item, index) in tab" :key="index"
				:label="item.title"
				width="160">

			<el-table-column
					v-for="(sub, i) in item.children" :key="i"
					:prop="sub.prop"
					:label="sub.title"
					width="160">
			</el-table-column>

		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {POWER_ANALYSIS_BY_LOOP} from "../../../api/power";
	import {monthDays,dateFormat} from "../../../util/DateUtil";
	import {floatFormat} from "../../../util/MathUtil";
	import exportExcel from "../../../util/excel";
	import ExcelJS from 'exceljs'
	import FileSaver from 'file-saver'
	export default {
		name: "PowerRange",
		props: {
			loops: Array,
			range: String,
			date: Date
		},
		data() {
			return {
				loading: false,
				show: true,
				tabData: [],
				tab: [
					{
						title: "尖",
						children: [
							{
								title: "尖电量",
								prop: "sum_tip"
							},
							{
								title: "尖占比",
								prop: "percentage_tip"
							}
						]
					},
					{
						title: "峰",
						children: [
							{
								title: "峰电量",
								prop: "sum_peak"
							},
							{
								title: "峰占比",
								prop: "percentage_peak"
							}
						]
					},
					{
						title: "平",
						children: [
							{
								title: "平电量",
								prop: "sum_level"
							},
							{
								title: "平占比",
								prop: "percentage_level"
							}
						]
					},
					{
						title: "谷",
						children: [
							{
								title: "谷电量",
								prop: "sum_valley"
							},
							{
								title: "谷占比",
								prop: "percentage_valley"
							}
						]
					},
				],
				dateName:""
			}
		},
		mounted() {
			this.requestData()
		},
		methods: {
			async requestData() {
				this.tabData = []
				if (this.loops.length <= 0) {
					return
				}
				this.loading = true
				let res = await Promise.all(this.loops.map(l => POWER_ANALYSIS_BY_LOOP(this.date, this.range, l.loopId)))
				let list = []
				try {
					this.loops.forEach((l, i) => {
						let resData = res[i].data.data.result
						if (resData) {
							let year = 'year_' + this.date.getFullYear()
							let month = 'month_' + (this.date.getMonth() + 1)

							// 总数居
							resData.date = '总'
							list.push(resData)

							if (this.range === 'month') {
								this.dateName = '月'
								let monthData = resData[year][month]

								for (let j = 1; j <= monthDays(this.date); j++) {
									let dayData = monthData['day_' + j]
									if (dayData) {
										dayData.total = dayData.daySum
										dayData.date = j + '日'
										list.push(dayData)
									}
								}

							} else {
								// 年的
								this.dateName = '年'
								let yearData = resData[year]
								for (let j = 1; j <= 12; j++) {
									let monthData = yearData['month_' + j]
									if (monthData) {
										monthData.total = monthData.monthSum
										monthData.date = j + '月'
										list.push(monthData)
									}
								}
							}

						} else {
							
						}
					})
					// console.log(list);

					list.forEach(e => {
						// 处理
						for (let k in e) {
							if (e.hasOwnProperty(k)) {
								if (k === 'date') {
									continue
								}
								if (e[k] === "NaN") {
									e[k] = '--';
									continue;
								}
								if (k.startsWith("percentage")) {
									e[k] = floatFormat(e[k] * 100, 2) + ' %'
								} else {
									e[k] = floatFormat(e[k], 2) + ' kWh'
								}
							}
						}

						["percentage_level",
							"percentage_peak",
							"percentage_tip",
							"percentage_valley",
							"sum_level",
							"sum_peak",
							"sum_tip",
							"sum_valley",
							"total"].forEach(k => {
							if(!e[k]){
								e[k] = '--'
							}
						})
					})
				} catch (e) {
					console.log(e)
					list = []
				}


				this.show = false
				this.tabData = list
				this.loading = false
				this.$nextTick(() => {
					this.show = true
				})


			}
		},
		computed: {
			selProjectName() {
				return this.$store.getters.selProjectInfo.projectName;
			},
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			propsData() {
				return [
					this.range,
					this.date,
					this.loops
				]
			}
		},
		watch: {
			diagramStatus(n){
				if(this.$route.query.uid === 'PowerRange' ){
					if(n.type === 'excel' && this.tabData.length > 0){

						let data = [
							['数据类型', '总电量'],
							['时间', '总电量'],
						]

						let merges = [
							{s: {r: 0, c: 1}, e: {r: 1, c: 1}},
						]

						this.tab.forEach((d, i) => {
							data[0].push(d.title, null)
							data[1].push(d.children[0].title, d.children[1].title)

							merges.push({s: {r: 0, c: 2 + i * 2}, e: {r: 0, c: 3 + i * 2}})
						})

						
						this.tabData.forEach(d => {
							data.push([
								d['date'],
								d['total'],
								d['sum_tip'],
								d['percentage_tip'],
								d['sum_peak'],
								d['percentage_peak'],
								d['sum_level'],
								d['percentage_level'],
								d['sum_valley'],
								d['percentage_valley'],
							])
						})
						// exportExcel(data, '尖峰平谷报表', merges)
						const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
							letter = letter.filter((e,i)=>i<10)

						//标题样式
						sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
						sheet.getCell(letter[0]+'1').value = '尖峰平谷' + this.dateName + '报表'
						sheet.getCell(letter[0]+'1').style={
							font: {
								name: 'Arial',
								size: 20,
								bold: true
							}
						}
						sheet.getCell(letter[0]+'1').alignment = { vertical: 'middle', horizontal: 'center' };
						
						sheet.getRow(1).height = 50
						//二级样式
						sheet.mergeCells('A2:D2');
						sheet.mergeCells('E2:'+letter[letter.length-1]+'2');
						sheet.getCell('A2').value = this.selProjectName
						sheet.getCell('E2').value = '日期：'+dateFormat("YY-mm-dd", new Date(this.date))
						sheet.getRow(2).font={
								name: 'Arial',
								size: 12,
								bold: true
						}
						sheet.getRow(2).alignment = { vertical: 'middle', horizontal: 'left' };
						sheet.getRow(2).height = 51

						sheet.addRow(['数据类型','总电量','尖','峰','平','谷']);
						sheet.mergeCells('B3:B4');
						sheet.mergeCells('C3:D3');
						sheet.mergeCells('E3:F3');
						sheet.mergeCells('G3:H3');
						sheet.mergeCells('I3:J3');
						sheet.getCell('E3').value = '峰';
						sheet.getCell('G3').value = '平';
						sheet.getCell('I3').value = '谷';

						//表格设置
						let columns = []
						data.forEach((item,index)=>{
							let list = []
							if(index<2){
								item.forEach(elm=>{
									// if(elm)
									list.push({
										name:elm,
									})
								})
								columns.push(list)
							}
						})
						
						sheet.addTable({
							name: 'MyTable',
							ref: 'A4', // 表格左上角的位置
							headerRow: true,
							totalsRow: false,
							style: {
								theme: 'TableStyleLight1',
								font:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
							},
								//            showRowStripes: true,
							columns:columns[1],
							rows: data.slice(2),
						})

						//表格头部样式
						

						
						let num = [3,4]
						letter.forEach(item=>{
							num.forEach(elm=>{
								sheet.getRow(elm).height = 59
								sheet.getRow(elm).font={
									name: 'Arial',
									size: 12,
									bold: true
								}
								sheet.getRow(elm).alignment = { vertical: 'middle', horizontal: 'center' };
								sheet.getCell(item+elm).fill = {
									type: 'gradient',
									gradient: 'angle',
									degree: 0,
									stops: [
										{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
										{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
										{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
									]
								};
								sheet.getCell(item+elm).border = {
									top: {style:'thin'},
									left: {style:'thin'},
									bottom: {style:'thin'},
									right: {style:'thin'}
								};
							})
							
						})
						data.slice(2).forEach((item,index)=>{
							sheet.getRow(5+index).height = 38
							sheet.getRow(5+index).font={
								name: 'Arial',
								size: 12,
								// bold: true
							}
							letter.forEach((e,i)=>{
								sheet.getColumn(e).width = 20
								sheet.getCell(e+(5+index)).border = {
									top: {style:'thin'},
									left: {style:'thin'},
									bottom: {style:'thin'},
									right: {style:'thin'}
								};
							})
						
							sheet.getRow(5+index).alignment = { vertical: 'middle', horizontal: 'center' };
						})
						

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `尖峰平谷${this.dateName}报表.xlsx`);
						})

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			propsData(n) {
				this.requestData()
			}
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>